import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/*
 * tailwind-merge only knows Tailwind's default scales, so the type-scale
 * tokens from the Umami theme in globals.css (text-h1, text-p-md, ...) must be registered as
 * font-size classes. Without this they are treated as text colors: a class
 * list like "text-label-sm text-green-700" would drop text-label-sm.
 * Color tokens (text-fg-*, bg-bg-*, ...) need no config, they really are
 * colors.
 */
const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            /*
             * Spacing and radius tokens from the Umami theme in globals.css, so p-l, gap-s,
             * mt-3xl, rounded-m etc. merge correctly against numeric
             * utilities like p-4.
             */
            spacing: ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl', '4xl'],
            radius: ['s', 'm', 'l', 'xl', '2xl', '3xl', '4xl'],
        },
        classGroups: {
            'font-size': [
                {
                    text: [
                        'display-lg',
                        'display-md',
                        'display-sm',
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'p-lg',
                        'p-md',
                        'p-sm',
                        'p-sm-bold',
                        'p-xs',
                        'label-lg',
                        'label-md',
                        'label-sm',
                    ],
                },
            ],
        },
    },
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
